import TravelerSelector, { CallbackClickUpdateValues } from '@ui/Search/Form/Fields/TravelerSelector/component'
import { debounce } from 'assets/core/js/common'

import type { TravelerValues } from '@ui/TravelerSelector/component'

export default (): void => {
  const input = document.getElementById('capacity') as HTMLInputElement
  if (input === null) {
    return
  }

  const travelerSelectorValuesUpdate = (values: TravelerValues): void => {
    input.value = JSON.stringify(values)
  }

  const travelerSelector = TravelerSelector(
    'capacity_traveler_selector',
    debounce(800, (updateValues: CallbackClickUpdateValues) => {
      updateValues()
    }),
    travelerSelectorValuesUpdate
  )

  // Initialize the component with the form value.
  if (travelerSelector !== null) {
    let decoded = null
    try {
      decoded = JSON.parse(input.value)
    } catch (exception) {
      console.error(exception)
    }

    if (
      typeof decoded !== 'object' ||
      decoded === null ||
      !Object.prototype.hasOwnProperty.call(decoded, 'adult') ||
      !(typeof (decoded as Record<'adult', unknown>).adult === 'number') ||
      !Object.prototype.hasOwnProperty.call(decoded, 'child') ||
      !(typeof (decoded as Record<'child', unknown>).child === 'number') ||
      !Object.prototype.hasOwnProperty.call(decoded, 'baby') ||
      !(typeof (decoded as Record<'baby', unknown>).baby === 'number') ||
      !Object.prototype.hasOwnProperty.call(decoded, 'pet') ||
      !(typeof (decoded as Record<'pet', unknown>).pet === 'number')
    ) {
      return
    }
    travelerSelector.setValues(decoded as TravelerValues)
  }
}
